import React, { Component } from 'react';
import PropTypes from 'prop-types';

const DefaultComponent = () => (<span />);

class RenderOnClient extends Component {
  static propTypes = {
    children: PropTypes.object,
    nonClientComponent: PropTypes.object,
  }

  constructor(props) {
    super(props);

    this.state = {
      canRender: false,
    };
  }

  componentDidMount() {
    this.setState({ canRender: true });
  }

  render() {
    const { children, nonClientComponent = <DefaultComponent /> } = this.props;
    const { canRender } = this.state;

    return canRender ? children : nonClientComponent;
  }
}

export default RenderOnClient;



// WEBPACK FOOTER //
// ./src/components/lib/RenderOnClient.js